/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../_chunks/dep-56ceb7ce.mjs';
import { computed, createVNode } from 'vue';
import { c as cloneDeep_1 } from '../../_chunks/dep-adebe2ce.mjs';
import log from '../../_common/js/log/log.mjs';
import { getStopStyle } from '../util/common.mjs';
import TSliderMark from '../slider-mark.mjs';
import { i as isArray_1 } from '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-2a2a0e63.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../hooks/useConfig.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-99a0abba.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';

var useSliderMark = function useSliderMark(config) {
  var name = config.value.prefixName;
  var markList = computed(function () {
    var markProps = config.value;
    if (!markProps.marks) {
      return [];
    }
    var legalMarks = [];
    if (isArray_1(markProps.marks)) {
      var marksList = cloneDeep_1(markProps.marks).sort(function (a, b) {
        return a - b;
      });
      var maxLimit = Math.max.apply(Math, _toConsumableArray(marksList).concat([markProps.max]));
      var minLimit = Math.min.apply(Math, _toConsumableArray(marksList).concat([markProps.min]));
      if (minLimit < markProps.min) {
        log.errorOnce("TSlider", "marks min value should >= props min");
      }
      if (maxLimit > markProps.max) {
        log.errorOnce("TSlider", "marks max value should <= props max");
      }
      marksList.forEach(function (item) {
        legalMarks.push({
          point: item,
          position: (item - minLimit) / (maxLimit - minLimit) * 100,
          mark: item
        });
      });
    } else {
      Object.keys(markProps.marks).map(parseFloat).sort(function (a, b) {
        return a - b;
      }).filter(function (point) {
        return point <= markProps.max && point >= markProps.min;
      }).forEach(function (point) {
        var item = {
          point: point,
          position: (point - markProps.min) * 100 / (markProps.max - markProps.min),
          mark: markProps.marks[point]
        };
        legalMarks.push(item);
      });
    }
    return legalMarks;
  });
  var renderMask = function renderMask(onChangeFn) {
    if (!markList.value.length) return null;
    return createVNode("div", null, [createVNode("div", {
      "class": "".concat(name, "__stops")
    }, [markList.value.map(function (item, index) {
      if (item.position === 0 || item.position === 100) return null;
      return createVNode("div", {
        "class": "".concat(name, "__stop ").concat(name, "__mark-stop"),
        "style": getStopStyle(item.position, config.value.vertical),
        "key": index
      }, null);
    })]), createVNode("div", {
      "class": "".concat(name, "__mark")
    }, [markList.value.map(function (item, key) {
      return createVNode(TSliderMark, {
        "mark": item.mark,
        "point": item.point,
        "key": key,
        "style": getStopStyle(item.position, config.value.vertical),
        "onClickMarkPoint": onChangeFn
      }, null);
    })])]);
  };
  return renderMask;
};

export { useSliderMark };
//# sourceMappingURL=useSliderMark.mjs.map
